/* src/components/heap.svelte generated by Svelte v3.43.1 */
import {
	SvelteComponent,
	append,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "../../_snowpack/pkg/svelte/internal.js";

function create_fragment(ctx) {
	let div;
	let h4;
	let t1;
	let pre;
	let t2;

	return {
		c() {
			div = element("div");
			h4 = element("h4");
			h4.textContent = "Heap";
			t1 = space();
			pre = element("pre");
			t2 = text(/*uiHeap*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, h4);
			append(div, t1);
			append(div, pre);
			append(pre, t2);
		},
		p(ctx, [dirty]) {
			if (dirty & /*uiHeap*/ 1) set_data(t2, /*uiHeap*/ ctx[0]);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let uiHeap;
	let { heap = [3, 99, 7, 2] } = $$props;

	$$self.$$set = $$props => {
		if ('heap' in $$props) $$invalidate(1, heap = $$props.heap);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*heap*/ 2) {
			// $: uiHeap = heap.map((n, i) => `${i}: ` + n.toString(16).padStart(2, '0').toUpperCase())
			$: $$invalidate(0, uiHeap = heap.map(n => n.toString(16).padStart(2, '0').toUpperCase()).join(''));
		}
	};

	return [uiHeap, heap];
}

class Heap extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { heap: 1 });
	}
}

export default Heap;